import { Component } from '@angular/core';
import { AuthentificationService } from '../../services/auth/authentification.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { StorageUtil } from '../../utils/storage.util';
import { environment } from '../../../environments/environment';

import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { AbstractFormComponent } from '../../core/abstract-form-component';
import { loginValidationMessages, getLoginControlsConfig } from './login.form';
import { userList } from './data';
import { CookieService } from 'ngx-cookie-service';

@Component({
  moduleId: module.id,
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.css'],
  providers: []
})
export class HomeComponent extends AbstractFormComponent {
  authByEsia: Boolean = false;
  authByForm: Boolean = false;
  statusAgree = false;
  model: any = {
    username: '',
    password: '',
  };

  settings: any = {};
  loading: boolean = false;
  errorMessage: string;
  serverValidationErrorMessage: any;

  loginModel: any = {
    sessionId: '',
    tenantType: '', // entity, individual
    inn: '',
    snils: '',
    ogrn: ''
  };

  constructor(
    private router: Router,
    private authService: AuthentificationService,
    private formBuilder: FormBuilder,
    private cookieService: CookieService
  ) {
    super();

    this.settings = environment;

    if(null !== this.findGetParameter('errorMessage')) {
        this.errorMessage = this.findGetParameter('errorMessage');
        console.log('error', this.findGetParameter('errorMessage'));
    }

    this.saveCookiesData();
    this.getCookies();

    this.authByEsia = this.settings.authType == 'esiaAuthenticated';
    this.authByForm = this.settings.authType == 'loginAuthenticated';
  }

  getCookies() {
   if (StorageUtil.getToken()) return;
    this.loading = true;

     this.authService.getCookies().subscribe(
      (data) => {
    this.loading = false;

        if (data && data.json()) {
            let token = data.json().secureToken;
            if (token) {
              AuthentificationService.saveToken(token);
            let tenantName = data.json().tenantName;
            StorageUtil.setTenantName(tenantName);

             location.reload(true);
            this.router.navigate(['/main']);

            }else {
StorageUtil.cleanTenantName();
StorageUtil.clear();
}

        }
      },
      (error) => {
    this.loading = false;

        console.error('Error:', error);
      }
    );
  }

  buildForm(): FormGroup {
    return this.formBuilder.group(getLoginControlsConfig(this.model, this.formBuilder));
  }

  getValidationMessages(): {} {
    return loginValidationMessages;
  }

  submit() {
    this.errorMessage = '';

    Object.assign(this.model, this.form.value);

    this.login();
  }

  apply() {
    this.login();
  }

  login() {
    this.loading = true;
    delete this.errorMessage;
    delete this.serverValidationErrorMessage;

    this.authService.login(this.model.username, this.model.password).subscribe(
      success => {
        console.log('success', success);
        if (success) {
          this.loading = false;
          if(success.json().error) {
            this.errorMessage = success.json().error.message;
          } else {
            let token = success.json().response && success.json().response.securityToken;
            if (token) {
              AuthentificationService.saveToken(token);
            }
            let tenantName = success.json().response && success.json().response.tenantName;
            StorageUtil.setTenantName(tenantName);
            location.reload(true);
            this.router.navigate(['/main']);
          }
        }
      },
      error => {
        console.log('error', error);
        if (error.status === 422) {
          this.serverValidationErrorMessage = error.json().errors;
        } else if (error.status === 401) {
          this.errorMessage = error.json().error;
        } else {
          this.errorMessage = 'Произошла ошибка.';
        }
        this.loading = false;
      },
      () => {
        this.loading = false;
      });
  }

  signIn($event) {
    this.loading = true;
    window.location.href = this.settings.authUrl;
  }

  setLogoStyle() {
    return {
      'background': 'url(' + this.settings.site.logo_url +') no-repeat 50% 0'
    };
  }

    saveCookiesData() {
        let token = this.cookieService.get('secureToken');
        console.log('Token', token);
        if (token) {
            AuthentificationService.saveToken(token);
        }
        let tenantName = this.cookieService.get('tenantName');
        if (tenantName) {
            StorageUtil.setTenantName(tenantName);
        }
        let tenantType = this.cookieService.get('tenantType');
        if (tenantType) {
            StorageUtil.setTenantType(tenantType);
        }

        this.router.navigate(['/main']);
    }

    findGetParameter(parameterName) {
        let result = null,
            tmp = [];
        location.search
            .substr(1)
            .split("&")
            .forEach(function (item) {
                tmp = item.split("=");
                if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });

        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts